import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

// Lazy load components
const ShipmentBatchList = lazy(() => import('./pages/ShipmentBatchList'));
const CreateShipmentBatch = lazy(() => import('./pages/CreateShipmentBatch'));
const ShipmentBatchDetails = lazy(() => import('./pages/ShipmentBatchDetails'));

const shipmentBatchRoutes: RouteObject[] = [
  {
    index: true,
    element: <ShipmentBatchList />,
  },
  {
    path: 'create',
    element: <CreateShipmentBatch />,
  },
  {
    path: ':id',
    element: <ShipmentBatchDetails />,
  },
];

export default shipmentBatchRoutes;
